import React from "react";
import styled from "styled-components";

export const FluidContainer = styled.div`
  box-sizing: border-box;
  flex: 1 1 auto;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  box-sizing: border-box;
  @media (max-width: ${p => p.theme.screen.mobile}) {
    padding: 0 1rem;
  }
`;

export const ContainerWide = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: auto;
  justify-content: center;
  align-items: center;

  max-width: ${p => p.theme.containers.lg};
  @media (max-width: ${props => props.theme.screen.medium}) {
    max-width: 100%;
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: auto;
  align-items: center;
  justify-content: center;
  max-width: ${p => p.theme.containers.md};
`;

export const ContainerSmall = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-width: ${p => p.theme.containers.sm};
`;

export const ContainerTiny = styled.div`
  display: flex;
  flex: auto;
  flex: 1 0 auto;
  align-self: center;
  max-width: ${p => p.theme.containers.xs};
`;

export const Background = styled.div`
  width: 100%;
  background: ${p => (p.color ? p.theme.colors[p.color] : "transparent")};
`;

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 100%;
`;

export const Center = styled.div`
  width: 100%;
  flex: auto;
  display: flex;
  justify-content: center;
`;

export const WithPadding = styled.div`
  flex-basis: 1 1 100%;
  padding-bottom: 80px;
  display: flex;
  justify-content: center;
`;

export const MainTitle = styled.h1`
  color: ${props =>
    props.color ? props.theme.colors[props.color] : props.theme.colors.text};
  margin-bottom: ${props =>
    props.margin ? props.theme.margins[props.margin] : 0};
  margin-right: ${props =>
    !!props.marginRight ? props.theme.margins[props.marginRight] : 0};
  display: ${props => (props.inline ? "inline-block" : "block")};
  font-weight: ${props => {
    if (props.black) return props.theme.weights.black;
    if (props.superbold) return props.theme.weights.superbold;
    if (props.bold) return props.theme.weights.bold;
    if (props.thin) return props.theme.weights.thin;
    return props.theme.weights.normal;
  }};
  font-size: ${props =>
    !!props.size
      ? props.theme.fontSizes[props.size]
      : props.theme.fontSizes.lg};
  text-transform: ${props => {
    if (props.capitalize) return "capitalize";
    if (props.uppercase) return "uppercase";
    return "none";
  }};
  line-height: ${props => (!!props.lineHeight ? props.lineHeight : 1.25)};
  text-align: ${props => (props.center ? "center" : "auto")};
  text-shadow: ${props => (props.shadow ? "0 0 10px rgba(0,0,0,1)" : "none")};
`;

export const Title = MainTitle.withComponent("h2");
export const Subtitle = MainTitle.withComponent("h3");

export const Text = styled.p`
  line-height: ${props => (!!props.lineHeight ? props.lineHeight : 1.5)};
  font-size: ${props =>
    !!props.fontSize
      ? props.theme.fontSizes[props.fontSize]
      : props.theme.fontSizes.nm};
  font-weight: ${props =>
    props.bold ? props.theme.weights.bold : props.theme.weights.regular};
  color: ${props =>
    props.color ? props.theme.colors[props.color] : props.theme.colors.text};
  padding-top: ${props =>
    !!props.paddingTop
      ? props.theme.margins[props.paddingTop]
      : props.theme.margins.md};
  padding-bottom: ${props =>
    !!props.paddingBottom
      ? props.theme.margins[props.paddingBottom]
      : props.theme.margins.md};

  margin-bottom: ${p => (p.margin ? p.theme.margins[p.margin] : "20px")};
  &:first-of-type {
    padding-top: 0;
  }
`;



// WEBPACK FOOTER //
// ./src/themes/Blocks.js